import React, { useEffect, useState } from 'react';
import { fetchProducts, deleteProduct } from '../../services/productService/productService';
import { useNavigate } from 'react-router-dom';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  const loadProducts = () => {
    fetchProducts()
      .then((data) => {
        const items = data.content || data;
        setProducts(items);
      })
      .catch((error) => console.error('Error fetching products:', error));
  };

  useEffect(() => {
    loadProducts();
  }, []);

  const handleDelete = async (id) => {
    const confirm = window.confirm('Are you sure you want to delete this product?');
    if (!confirm) return;
    try {
      await deleteProduct(id);
      loadProducts();
    } catch (error) {
      console.error('Failed to delete product:', error);
      alert('Failed to delete product. Please try again.');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('isAdmin');
    navigate('/admin/login');
  };

  return (
    <div className="admin-container">
      <h2 className="admin-heading">Admin Dashboard</h2>
      <p className="admin-subheading">Manage all your products below</p>

      <div className="admin-top-bar">
        <button className="admin-add-btn" onClick={() => navigate('/admin/add-product')}>
          + Add New Product
        </button>
        <button className="admin-logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>

      <div className="admin-table-wrapper">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Image</th>
              <th>Name</th>
              <th>Category</th>
              <th>Specs</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {products.length === 0 ? (
              <tr>
                <td colSpan="5" className="admin-no-data">No products found.</td>
              </tr>
            ) : (
              products.map((product) => (
                <tr key={product.id}>
                  <td>
                    <img src={product.image} alt={product.name} className="admin-image" />
                  </td>
                  <td>{product.name}</td>
                  <td>{product.category || 'N/A'}</td>
                  <td>{product.specs}</td>
                  <td>
                    <button
                      className="admin-edit-btn"
                      onClick={() => navigate(`/admin/edit/${product.id}`)}
                    >
                      Edit
                    </button>
                    <button
                      className="admin-delete-btn"
                      onClick={() => handleDelete(product.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminDashboard;
